import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const usePricingMethods = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'pricingMethods',
    gqlEntityKey: 'pricing_methods',
    queryName: 'GET_PRICING_METHODS_QUERY',
    createMutation: 'CREATE_PRICING_METHOD_MUTATION',
    updateMutation: 'UPDATE_PRICING_METHOD_MUTATION',
    deleteMutation: 'DELETE_PRICING_METHOD_MUTATION',
    updateVariableName: 'set',
    transformData: (pricingMethod) => ({
      ...pricingMethod,
      company_name: pricingMethod.company?.name || `Company ${pricingMethod.company_id}`,
      name: pricingMethod.name,
      description: pricingMethod.description,
      status: pricingMethod.status ? 'active' : 'inactive',
      companyId: pricingMethod.company_id,
    }),
    transformFormData: (formData) => ({
      name: formData.name,
      description: formData.description || null,
      status: formData.status === 'active',
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { usePricingMethods }; 